import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { QuangularToasterService } from '@app/services/common/toaster.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private readonly qToaster: QuangularToasterService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
  return next.handle(request).pipe(
    catchError((error: HttpErrorResponse) => {
      // 1. Handle Blob error responses (typically from file downloads)
      if (error.error instanceof Blob && error.error.type === 'application/json') {
        return new Observable<HttpEvent<unknown>>((observer) => {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              let errorMsg = null;
              const errorJson = JSON.parse(reader.result as string);
              if (errorJson?.error?.code !== 'ImageNotFound') {
                errorMsg = 'File is not available.';
              }

              if (errorMsg) { 
                this.qToaster.showToast({
                  status: 'error',
                  summary: 'Error',
                  message: errorMsg,
                });
              }
            } catch {
              this.qToaster.showToast({
                status: 'error',
                summary: 'Error',
                message: 'Unknown error occurred (failed to parse JSON)',
              });
            }

            observer.error(error);
          };

          reader.onerror = () => {
            this.qToaster.showToast({
              status: 'error',
              summary: 'Error',
              message: 'Failed to read error response',
            });

            observer.error(error);
          };

          reader.readAsText(error.error);
        });
      }

      // 2. Handle client-side/network error
      let errorMsg = '';
      if (error.error instanceof ErrorEvent) {
        errorMsg = `Client-side error: ${error.error.message}`;
      } else {
        // 3. Handle known HTTP status codes
        switch (error.status) {
          case 401:
            errorMsg = error?.error?.message || 'Unauthorized';
            break;
          case 403:
            errorMsg = 'Forbidden';
            break;
          case 404:
            errorMsg = `Sorry, can't find that!`;
            break;
          case 504:
            errorMsg = 'Session Timeout';
            break;
          case 500:
            errorMsg = error?.error?.message || 'Server Error';
            break;
          // default:
          //   // Fallback for unknown server errors
          //   if (typeof error.error === 'string') {
          //     errorMsg = error.error;
          //   } else {
          //     errorMsg = error?.error?.message || error?.message || 'Unknown Error';
          //   }
          //   break;
        }
      }

      if (errorMsg) {
        this.qToaster.showToast({
          status: 'error',
          summary: 'Error',
          message: errorMsg,
        });
      }

      return throwError(() => error);
    })
  );
}


}
